import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=199b544d&scoped=true"
import script from "./tiktok.vue?vue&type=script&lang=js"
export * from "./tiktok.vue?vue&type=script&lang=js"
import style0 from "./tiktok.vue?vue&type=style&index=0&id=199b544d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b544d",
  null
  
)

export default component.exports